import { render, staticRenderFns } from "./Exhibition.vue?vue&type=template&id=b5fd985c&scoped=true"
import script from "./Exhibition.vue?vue&type=script&lang=js"
export * from "./Exhibition.vue?vue&type=script&lang=js"
import style0 from "./Exhibition.vue?vue&type=style&index=0&id=b5fd985c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5fd985c",
  null
  
)

export default component.exports